import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — reset scroll on route change.
 * Supports #hash anchors: if a hash is present, scrolls smoothly to that element
 * once it exists in the DOM.
 */
export function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            // wait one tick for the new page to render, then scroll to element
            const id = hash.replace("#", "");
            const tryScroll = (attempt = 0) => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                } else if (attempt < 10) {
                    setTimeout(() => tryScroll(attempt + 1), 50);
                }
            };
            // initial scroll to top, then anchor
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
            tryScroll();
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }
    }, [pathname, hash]);
    return null;
}

export default ScrollToTop;
